import { Validator } from '@thinknimble/tn-forms'
import { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input'

/**
 * Validates a phone number string using libphonenumber-js.
 * Returns true if the value is a valid international phone number.
 */
export function isValidPhone(value: string | null | undefined): boolean {
  if (!value) return false
  try {
    return isValidPhoneNumber(value)
  } catch {
    return false
  }
}

/**
 * Normalizes a stored phone (possibly legacy free text) to E.164 for
 * PhoneNumberInput. Returns undefined when it can't be parsed.
 */
export function toE164(value: string | null | undefined): string | undefined {
  if (!value) return undefined
  try {
    return parsePhoneNumber(value, 'CO')?.number
  } catch {
    return undefined
  }
}

/** tn-forms validator; with isRequired false an empty value passes. */
export class PhoneNumberValidator extends Validator {
  constructor({
    message = 'Enter a valid phone number',
    code = 'invalidPhone',
    isRequired = true,
  } = {}) {
    super({ message, code, isRequired })
  }

  call(value: string | null | undefined) {
    if (!this.enableValidate && !value) return
    if (!isValidPhone(value)) {
      throw new Error(JSON.stringify({ code: this.code, message: this.message }))
    }
  }
}
